import apiClient from "./axios"

// Get all customer designations with optional filtering
export const getCustomerDesignations = async (params = {}) => {
  const { data } = await apiClient.get("/customer-designations", { params })
  return data
}

// Get a specific customer designation by ID
export const getCustomerDesignation = async id => {
  const { data } = await apiClient.get(`/customer-designations/${id}`)
  return data
}

// Create a new customer designation
export const createCustomerDesignation = async designationData => {
  const { data } = await apiClient.post("/customer-designations", designationData)
  return data
}

// Update an existing customer designation
export const editCustomerDesignation = async ({ id, ...designationData }) => {
  const { data } = await apiClient.patch(`/customer-designations/${id}`, designationData)
  return data
}

// Delete a customer designation (soft delete)
export const deleteCustomerDesignation = async id => {
  const { data } = await apiClient.delete(`/customer-designations/${id}`)
  return data
}

// Get all customer designations without pagination
export const getAllCustomerDesignations = async (params = {}) => {
  const { data } = await apiClient.get("/customer-designations", {
    params: { ...params, all: true },
  })
  return data
}

// Search customer designations by name or slug
export const searchCustomerDesignations = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/customer-designations", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed customer designations
export const getTrashedCustomerDesignations = async (params = {}) => {
  const { data } = await apiClient.get("/customer-designations/trashed", { params })
  return data
}

// Get a customer designation by slug
export const getCustomerDesignationBySlug = async slug => {
  const { data } = await apiClient.get(`/customer-designations/slug/${slug}`)
  return data
}

// Restore a trashed customer designation
export const restoreCustomerDesignation = async id => {
  const { data } = await apiClient.post(`/customer-designations/${id}/restore`)
  return data
}
